interface AgencyBranding {
  brandName: string;
  logoUrl?: string;
  primaryColor?: string;
  websiteUrl?: string;
}

interface StoreLocatorFooterProps {
  cities: string[];
  selectedCity: string;
  brandName: string;
  theme: any;
  subdomain: string;
  onCityClick: (city: string) => void;
  agencyBranding?: AgencyBranding;
}

const StoreLocatorFooter = ({
  cities,
  selectedCity,
  brandName,
  theme,
  subdomain,
  onCityClick,
  agencyBranding,
}: StoreLocatorFooterProps) => {
  return (
    <footer className="bg-white border-t py-3 md:py-4">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <div className="flex flex-wrap justify-center items-center gap-1 md:gap-2 text-xs md:text-sm text-gray-700">
          {cities.map((city, index) => (
            <div key={city} className="flex items-center">
              <button
                onClick={() => onCityClick(city)}
                className={`hover:text-blue-600 transition-colors ${
                  selectedCity === city ? 'text-blue-600 font-semibold' : ''
                }`}
                style={{
                  color: selectedCity === city ? theme?.primaryColor : undefined,
                }}
              >
                {brandName} in {city}
              </button>
              {index < cities.length - 1 && (
                <span className="mx-1 md:mx-2 text-gray-400">|</span>
              )}
            </div>
          ))}
        </div>
        <p className="text-xs md:text-sm text-gray-500 mt-2">
          Powered by{' '}
          {agencyBranding ? (
            <a
              href={agencyBranding.websiteUrl || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline font-medium"
              style={{ color: agencyBranding.primaryColor || '#2563eb' }}
            >
              {agencyBranding.brandName}
            </a>
          ) : (
            <a
              href="https://www.fly-social.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Fly
            </a>
          )}
        </p>
      </div>
    </footer>
  );
};

export default StoreLocatorFooter;
